















































































import { Component, Vue } from 'vue-property-decorator';
import SubjectContainer from '@/components/subjects/SubjectContainer.vue';
import SubjectStore, {
  SubjectStoreInterface,
} from '@/resource/subject/subject.store';
import TitleContainer from '@/components/common/TitleContainer.vue';
import ModalSubject from '@/components/modals/ModalSubject.vue';
import ModalSubjectNotAvail from '@/components/modals/ModalSubjectNotAvail.vue';
import NavigationTab from '@/components/common/NavigationTab.vue';
import {
  SubjectType,
  SubjectTypeFriendlyValue,
} from '@/resource/subject/subject.model';
import getEnumValue from '@/utils/common/get-enum-value';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import seoDefault from '@/utils/seo-default';

export interface SubjectBlock {
  name: string;
  path: string;
  isAvailable: boolean;
}

interface SujectClickedParams {
  subject: SubjectBlock;
  subjectType: SubjectType;
}

@Component({
  components: {
    TitleContainer,
    SubjectContainer,
    ModalSubject,
    ModalSubjectNotAvail,
    NavigationTab,
  },
  metaInfo(this: Subjects): MetaInfo {
    return {
      title: 'Subjects |',
      meta: [
        ...seoDefault({
          title: 'Subjects | Mysoalan',
          description:
            'Subjects are the place where you can explore thousands of questions for any subject. You can filter questions by chapters, difficulties, languages, and more!',
        }),
      ],
    };
  },
})
export default class Subjects extends Vue {
  subjectStore: SubjectStoreInterface = SubjectStore;
  isLoading = true;
  showSubjectModal = false;
  showSubjectNotAvailModal = false;
  selectedSubject: SubjectBlock | null = null;
  selectedSubjectType: SubjectType | null = null;
  selectedSubjectlabel = '';

  activeTab = 0;

  lowerFormType = SubjectType.LowerForm;
  upperFormType = SubjectType.UpperForm;
  elementaryType = SubjectType.Elementary;

  mainTitle = [
    {
      type: 'normal',
      value: 'Our',
    },
    {
      type: 'highlight',
      value: 'available',
    },
    {
      type: 'normal',
      value: 'subjects',
    },
  ];

  mainP = `Subjects are the place where you can explore thousands of questions
          for any subject. You can filter questions by chapters, difficulties,
          languages, and more!`;

  get lowerFormSubjects(): SubjectBlock[] {
    return this.subjectStore.lowerFormSubjects.map(subject => {
      // const chapterIds = subject.chapters.map(chapter => chapter.id);

      return {
        name: subject.name,
        path: `${subject.uuid}`,
        isAvailable: subject.isAvailable,
      };
    });
  }

  get upperFormSubjects(): SubjectBlock[] {
    return this.subjectStore.upperFormSubjects.map(subject => {
      // const chapterIds = subject.chapters.map(chapter => chapter.id);

      return {
        name: subject.name,
        path: `${subject.uuid}`,
        isAvailable: subject.isAvailable,
      };
    });
  }

  get elementarySubjects(): SubjectBlock[] {
    return this.subjectStore.elementarySubjects.map(subject => {
      // const chapterIds = subject.chapters.map(chapter => chapter.id);

      return {
        name: subject.name,
        path: `${subject.uuid}`,
        isAvailable: subject.isAvailable,
      };
    });
  }

  async created() {
    await this.subjectStore.fetchLowerFormSubjects();
    await this.subjectStore.fetchUpperFormSubjects();
    await this.subjectStore.fetchElementaryFormSubjects();
    this.isLoading = false;
  }

  closeSubjectModal() {
    this.showSubjectModal = false;
  }

  closeSubjectNotAvail() {
    this.showSubjectNotAvailModal = false;
  }

  openSubjectModal(params: SujectClickedParams) {
    if (params.subject) {
      this.selectedSubject = params.subject;
      this.selectedSubjectType = params.subjectType;

      this.selectedSubjectlabel = getEnumValue(
        params.subjectType,
        SubjectTypeFriendlyValue,
      );

      if (params.subject.isAvailable) {
        this.showSubjectModal = true;
      } else {
        this.showSubjectNotAvailModal = true;
      }
    }
  }

  updateActiveTab(index: number) {
    this.activeTab = index;
  }
}
